import InfoField from "./InfoField";
import { getCardinalDirectionFromAngle } from "../services/weather.service";
import InfoFieldsContainer from "./InfoFieldsContainer";
import { useSelector } from "react-redux";

export const ReviewDisplay = () => {
	const values = useSelector(state => state.submission);
	const { info, location, fuelLoad, weather, comments, closestSSA, recommendation } = values;

	return (
		<InfoFieldsContainer>
			<InfoField reverse title="Name:" align="right">
				{info.name}
			</InfoField>
			<InfoField reverse title="Phone:" align="right">
				{info.phoneNum}
			</InfoField>
			<InfoField reverse title="Start Date:" align="right">
				{new Date(info.startDate).toLocaleString()}
			</InfoField>
			<InfoField reverse title="End Date:" align="right">
				{new Date(info.endDate).toLocaleString()}
			</InfoField>
			<InfoField reverse title="County:" align="right" gridItemProps={{style:{overflow:'hidden', textOverflow:'ellipsis'}}}>
				{location ? location.county : ''}
			</InfoField>
			<InfoField reverse title="Location:" align="right" gridItemProps={{style:{overflow:'hidden', textOverflow:'ellipsis'}}}>
				{location && location.coords ? `lat: ${location.coords.latitude.toFixed(2)}°, lng: ${location.coords.longitude.toFixed(2)}°`: ''}
			</InfoField>

			<InfoField reverse title="Field Crop/Forestry:" align="right" mt={4}>
				{fuelLoad.cropType}
			</InfoField>
			<InfoField reverse title="Fuel Loading:" align="right">
				{fuelLoad.fuelLoadingRange == null ? '' : ['Low', 'Medium', 'Heavy'][fuelLoad.fuelLoadingRange]} 
			</InfoField>
			<InfoField reverse title="Total Acres:" align="right">
				{fuelLoad.totalAcres}
			</InfoField>
			<InfoField reverse title="Total Tonnage:" align="right">
				{fuelLoad.totalTonnage.toFixed(2)}
			</InfoField>

			<InfoField reverse horizontal title="Nearest SSA:" mt={4}>
				{closestSSA ?
					<span>
						{closestSSA.name} - {closestSSA.type} <br />
						{closestSSA.address}
					</span>
					: ''
				}
			</InfoField>

			<InfoField reverse horizontal title="Additional Information:" mt={4}>
				{comments}
			</InfoField>

			<InfoField reverse title="Category Day:" align="right" mt={4}>
				{weather.catDay}
			</InfoField>
			<InfoField reverse title="Wind Direction:" align="right">
				{weather.windDirection && weather.windDirection.value ? weather.windDirection.value + '°' : 'null'} {weather.windDirection ? getCardinalDirectionFromAngle(weather.windDirection.value) : ''}
			</InfoField>
			<InfoField reverse title="Wind Speed:" align="right">
				{weather.windSpeed && weather.windSpeed.value ? weather.windSpeed.value + ' mph' : 'null'}
			</InfoField>
			<InfoField reverse title="Humidity:" align="right">
				{weather.humidity && weather.humidity.value ? weather.humidity.value + '%' : 'null'}
			</InfoField>

			<InfoField reverse title="Total Tonnage of this Burn:" align="right" mt={4}>
				{recommendation.totalTonnageForThisBurn.toFixed(1)}
			</InfoField>
			<InfoField reverse title="Total Tonnage within Airshed:" align="right">
				{recommendation.totalTonnageForAllBurns.toFixed(1)}
			</InfoField>
		</InfoFieldsContainer>
	)
}